import React from 'react';

import { Avatar, List, Typography } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';

import { SETTINGS_EXTRA_COLUMN_WIDTH } from './constants';
import { useSettingsContext } from './SettingsContext';

const StyledListItem = styled(List.Item)`
  background-color: white;
  cursor: pointer;

  &&.ant-list-item {
    padding: 15px 10px 15px 15px;
  }

  &:hover {
    background-color: var(--background-gray-light);
  }
`;

const AvatarLetter = styled(Typography.Text)`
  font-size: 10px;
  line-height: 10px;
  font-weight: 500;
  color: #0ab776;

  &&.ant-avatar-string {
    display: flex;
  }
`;

const CommunityName = styled(Typography.Text)`
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
`;

const StatusContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const StyledLeftContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const RightContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 20px;
`;

const ExtraColumnValue = styled(Typography.Text)`
  width: ${SETTINGS_EXTRA_COLUMN_WIDTH}px;
  font-size: 12px;
  color: var(--text-primary);
  text-align: left;
`;

type Props = {
  item: any;
  renderExtraColumns?: (item: any) => React.ReactNode[];
  isSelected: boolean;
  onClick: (item: any) => void;
};

const CommunityListItem = ({ item, renderExtraColumns, isSelected, onClick }: Props) => {
  const { isMultipleSelection, getItemStatusComponent, toggleOneCommunity } = useSettingsContext();
  const extraColumns = renderExtraColumns?.(item) || [];
  const showExtraColumns = extraColumns.length > 0;

  let checkbox;
  if (isMultipleSelection) {
    checkbox = (
      <Checkbox checked={isSelected} onChange={() => toggleOneCommunity(item)} style={{ marginRight: '15px' }} />
    );
  }

  const status = getItemStatusComponent(item);

  return (
    <StyledListItem style={{ cursor: isMultipleSelection ? 'auto' : 'pointer' }} onClick={() => onClick(item)}>
      <StyledLeftContainer>
        {checkbox}
        <Avatar
          size={30}
          style={{
            backgroundColor: '#e2f5ee',
            border: 'solid 1px var(--positive-green)',
            color: 'var(--positive-green)',
          }}
        >
          <AvatarLetter>{item.comunity_name.charAt(0)}</AvatarLetter>
        </Avatar>
        <CommunityName>{item.comunity_name}</CommunityName>
      </StyledLeftContainer>
      <RightContentContainer>
        {showExtraColumns &&
          extraColumns.map((column, index) => <ExtraColumnValue key={index}>{column}</ExtraColumnValue>)}
        <StatusContainer>
          {status}
          <img src="/icons/chevron-right.svg" style={{ width: '24px', height: '24px' }} />
        </StatusContainer>
      </RightContentContainer>
    </StyledListItem>
  );
};

export default CommunityListItem;
